<script setup>
import {  defineProps } from 'vue';

defineProps({
  width: {
    type: String,
    required: true,
  },
  align: {
    type: String,
    default: 'left',
  }
});

</script>

<template>
  <div
    :style="'width: ' + width +'rem;'"
    :class="[
      'cursor-not-allowed bg-metal-800 text-metal-300 pt-2.5 border-b border-t border-b-metal-800 border-t-metal-800 text-' + align,
    ]"
  >
    <slot></slot>
  </div>
</template>
